import React from 'react';
import { LoadingCurtain } from './components/LoadingCurtain';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Opening } from './components/Opening';
import { Gallery } from './components/Gallery';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Experience } from './components/Experience';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Results } from './components/Results';
import { Aftercare } from './components/Aftercare';
import { Academy } from './components/Academy';
import { ForWho } from './components/ForWho';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-beige-50 selection:bg-gold-200 selection:text-gold-900" data-id="element-0">
      <LoadingCurtain data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Gallery data-id="element-5" />
        <Opening data-id="element-6" />
        <Problem data-id="element-7" />
        <Solution data-id="element-8" />
        <Experience data-id="element-9" />
        <Services data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Results data-id="element-12" />
        <Aftercare data-id="element-13" />
        <Academy data-id="element-14" />
        <ForWho data-id="element-15" />
        <FAQ data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
      <WhatsAppButton data-id="element-19" />
    </div>;
}